<template>
  <div class="preview" :class="{ 'miniprogram-preview': isMiniprogram }">
    <!--  <img class="image" :src="data.questionImage" alt=""> -->
    <div class="list">
      <div
        class="item"
        :class="{
          'item-active': index == step - 1 || (step == 0 && index == 0),
          'item-gou': index == step,
          'item-confirm': index < step
        }"
        v-for="(item, index) in list"
        :key="index"
      >
        <div class="item-dot">
          <div class="mask-content">
            <div class="mask"></div>
          </div>
          <div class="iconfont icon-gou" v-if="index < step"></div>
        </div>
        <div class="item-line" v-if="index < list.length - 1"></div>
        <div class="item-title">{{ item.title }}</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => {
        return {}
      }
    },
    theme: {
      type: Object,
      default: () => {
        return {}
      }
    },
    step: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      list: [
        {
          title: '基础情况'
        },
        {
          title: '身体状态'
        },
        {
          title: '饮食习惯'
        },
        {
          title: '生活习惯'
        }
      ],
      isMiniprogram: false
    }
  },
  created() {
    if (!window.WeixinJSBridge || !WeixinJSBridge.invoke) {
      document.addEventListener('WeixinJSBridgeReady', this.ready, false)
    } else {
      this.ready()
    }
  },
  methods: {
    ready() {
      this.isMiniprogram = window.__wxjs_environment === 'miniprogram'
    }
  }
}
</script>
<style lang="scss" scoped>
.preview {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  align-items: center;
  justify-content: center;
}

.miniprogram-preview {
  top: 40%;
}

.list {
  display: inline-flex;
  flex-direction: column;

  .item {
    display: flex;
    padding-left: 60px;
    padding-bottom: 30px;
    position: relative;

    .item-dot {
      overflow: hidden;
      display: flex;
      align-items: center;
      justify-content: center;
      position: absolute;
      width: 10px;
      height: 10px;
      left: 14px;
      top: calc(50% - 15px);
      transform: translate(-50%, -50%);
      background: #697387;
      border-radius: 50%;
      z-index: 1;

      .mask-content {
        position: absolute;
        overflow: hidden;
        border-radius: 50%;
        width: 22px;
        height: 22px;
        transform: translate(-50%, -50%);
        left: 50%;
        top: 50%;
      }

      .mask {
        position: absolute;
        width: 100%;
        height: 100%;
        left: 100%;
        top: 50%;
        transform: translate(0%, -50%);
        background-color: #ff411e;
        display: none;
      }

      .iconfont {
        color: rgba(0, 0, 0, 0.8);
      }
    }

    .item-line {
      position: absolute;
      height: 100%;
      left: 13px;
      top: 21px;
      width: 0px;
      height: 100%;
      border-left: 2px dashed #c0c2d0;
    }

    .item-title {
      font-size: 18px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: rgba(0, 0, 0, 0.5);
      line-height: 32px;
    }
  }

  .item-confirm {
    .item-dot {
      width: 26px;
      box-sizing: border-box;
      height: 26px;
      background: #ffffff;
      border: 3px solid #373d52;
    }
  }

  .item-active {
    .item-dot {
      width: 28px;
      height: 28px;
      box-sizing: border-box;
      background: #ff411e;
      border: none;

      .mask {
        display: block;
        animation: animateMove 1s ease;
      }

      .iconfont {
        font-weight: 600;
        color: #fff;
      }
    }

    .item-title {
      font-size: 24px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: rgba(0, 0, 0, 0.8);
      line-height: 32px;
    }
  }

  .item:last-child {
    padding-bottom: 0;

    .item-dot {
      top: 50%;
    }
  }
}

.image {
  width: 100%;
}

@keyframes animateMove {
  0% {
    left: 0%;
  }

  100% {
    left: 100%;
  }
}
</style>
